import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './js/App';


const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
const bookingStartInfo = window.bookingStartInfo;

root.render(
    
    <React.Fragment>
        <div className='body-content'>
            <div className='container'>
                <div className="grid lg:grid-cols-12 gap-6">
                    <div className="lg:col-start-2 lg:col-end-12">
                        <div>
                            <App bookingStartInfo={bookingStartInfo}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment>
);